import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const StackedBlockFooter = props => {
  const { className, children, ...other } = props;
  return (
    <div className={clsx("em-c-stacked-block__footer", className)} {...other}>
      {children}
    </div>
  );
};

StackedBlockFooter.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

StackedBlockFooter.defaultProps = {
  className: "",
  children: null
};

export default StackedBlockFooter;
